// 1. React
import { memo, useCallback } from "react";

// 2. API
import { getFleetVehicleExpenseStatsAPI } from "services/api/fleet/vehicles/expenses/api";

// 3. Local Components
import VehicleExpenseStats from "../../../VehicleExpenseSearchPage/components/VehicleExpenseStats/VehicleExpenseStats";

// 4. Types
import { VehicleExpenseStatsCardProps } from "./types";

const VehicleExpenseStatsCard: React.FC<VehicleExpenseStatsCardProps> = ({
    fleetVehicleDetail,
}) => {
    const vehicleId = fleetVehicleDetail.id;

    // useCallback drži referencu stabilnom — inače bi se useEffect u Monthly/Weekly
    // okidao na svaki render parenta jer fetchStats dolazi u useEffect deps.
    const fetchStats = useCallback(
        () => getFleetVehicleExpenseStatsAPI(vehicleId!),
        [vehicleId]
    );

    if (!vehicleId) return null;

    return <VehicleExpenseStats fetchStats={fetchStats} />;
};

export default memo(VehicleExpenseStatsCard);
